import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../../tokens/theme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: ${theme.light.ui.background.default};
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 0.5rem;
`;

const Message = styled.p`
  font-size: 1.125rem;
  color: ${theme.light.text.staticIconsTertiary};
  margin-bottom: 1.5rem;
`;

const BackButton = styled.button`
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #007079;
  color: #fff;

  &:hover {
    background-color: #004f55;
  }
`;

export function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = 'Something went wrong';
  let message = 'An unexpected error occurred.';

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    message =
      error.data?.message ?? error.data ?? 'An unexpected error occurred.';
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <Wrapper role="alert">
      <Title>{title}</Title>
      <Message>{message}</Message>
      <BackButton onClick={() => navigate('/')}>Go home</BackButton>
    </Wrapper>
  );
}
